import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconIconists: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconIconists"><Path d="M12 2V22L8 20V4L12 2Z" fill="currentColor"/><Path opacity="0.35" d="M16 4V20L12 22V2L16 4Z" fill="currentColor"/></CentralIconBase>;
});

export default IconIconists;
